import { EMPTY_FIELD } from 'constants/emptyField';

import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { formatInputInTz } from 'utils/date';
import { formatTimeZoneLabel } from 'utils/formatTimeZoneLabel';
import { getTimezoneByName } from 'utils/getTimezoneByName';

type Props = Omit<FunctionFieldProps, 'render'> & {
  startDateSource?: string;
  endDateSource?: string;
};

export const PeriodTzActivityField: React.FC<Props> = ({
  startDateSource = 'startDateMilliseconds',
  endDateSource = 'endDateMilliseconds',
  ...restProps
}) => {
  const formatDate = (timestampSeconds: number | string) => {
    return formatInputInTz(timestampSeconds, { format: 'dd.MM.yyyy' });
  };

  const renderPeriod = (record: Record<string, any>) => {
    const startRaw = (record as Record<string, any>)?.[startDateSource];
    const endRaw = (record as Record<string, any>)?.[endDateSource];

    if (!startRaw && !endRaw) {
      return EMPTY_FIELD;
    }

    const start = startRaw ? formatDate(startRaw) : null;
    const end = endRaw ? formatDate(endRaw) : null;
    const timeZone = record.timeZone ? getTimezoneByName(record.timeZone) : null;

    let date = EMPTY_FIELD;

    if (start && end) {
      date = `${start} - ${end}`;
    }

    if (start && !end) {
      date = `${start}  - Нет`;
    }

    return (
      <Stack>
        <Typography fontWeight={500} sx={{ textWrap: 'nowrap' }} variant="body2">
          {date}
        </Typography>
        <Typography color="secondary.main" sx={{ textWrap: 'nowrap' }} variant="body2">
          {timeZone
            ? `${timeZone?.name} (${timeZone?.offset})`
            : formatTimeZoneLabel(DEFAULT_TIMEZONE)}
        </Typography>
      </Stack>
    );
  };

  return <FunctionField {...restProps} render={renderPeriod} sortable={false} />;
};
